import { Backend } from '.';

/*

     unsubscribe_pwa_newsletter_subscriptions POST   /pwa/1/customer/newsletter_subscriptions/unsubscribe(.:format)          faceless/pwa/customer/newsletter_subscriptions#unsubscribe
                                              DELETE /pwa/1/customer/newsletter_subscriptions/token/:token(.:format)         faceless/pwa/customer/newsletter_subscriptions#destroy

 */

export interface NewsletterSubscriber {
  email: string;
  firstname?: string;
  lastname?: string;
  street?: string;
  address_addition?: string;
  zip_code?: string;
  city?: string;
  country?: string;
  phone?: string;
  birthday_on?: Date;
  locale: string;
  newsletter_interest_ids?: [];
}

export interface NewsletterInterest {
  id: number;
  title: string;
}

export async function subscribe(subscriber: NewsletterSubscriber) {
  return Backend.post<NewsletterSubscriber>('/customer/newsletter_subscriptions/subscribe', {
    body: JSON.stringify({
      newsletter_subscriber: subscriber,
    }),
  });
}

export async function confirmSubscription(confirmationToken: string) {
  return Backend.post<string>(
    `/customer/newsletter_subscriptions/confirm/token/${encodeURIComponent(confirmationToken)}`
  );
}

export async function unsubscribe(email: string) {
  return Backend.post<boolean>('/customer/newsletter_subscriptions/unsubscribe', {
    body: JSON.stringify({
      email,
    }),
  });
}

export async function delSubscription(confirmationToken: string) {
  return Backend.del<string>(`/customer/newsletter_subscriptions/token/${encodeURIComponent(confirmationToken)}`);
}

export async function getNewsletterInterests() {
  return Backend.get<NewsletterInterest[]>('/catalog/newsletter_interests');
}

export default {
  subscribe,
  confirmSubscription,
  unsubscribe,
  delSubscription,
  getNewsletterInterests,
};
